<template>
    <b-button v-if="id" :size="size ? size : 'sm'" v-on:click="confirmDelete()" :variant="variant ? variant : 'danger'">
        <i class="fa fa-times" v-if="!hideIcon" aria-hidden="true"></i> {{!hideText ? this.$i18n.t('buttons.verwijderen') : ''}}
    </b-button>
</template>
<script>
export default {
    name:'controls-delete',
    props: ['size','variant','hideIcon','hideText','noRedirect','title','id','entityId','namespace','resource'],
    methods: {
        confirmDelete() {
            var vm = this;
            vm.$swal ({
                title: `${vm.title} ${this.$i18n.t('delete.verwijderen')}`,
                text: `${this.$i18n.t('delete.weetuzekerdatudeze')} ${vm.title.toLowerCase()} ${this.$i18n.t('delete.wiltverwijderen')}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: this.$i18n.t('delete.javerwijderen'),
                cancelButtonText: this.$i18n.t('delete.neeannuleren')
            })
            .then((result) => {
                if (result.value) 
                {
                    var i18n = this.$i18n;
                    var vm = this;
                    var messagebox = vm.$swal({
                        html: `<div class="sweet_loader"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div>`,
                        showConfirmButton: false,
                    })
                    var payload = {
                        resource: vm.resource, 
                        entityId: vm.entityId,
                        id: vm.id
                    };
                    vm.$store.dispatch(`${vm.namespace}/delete`,payload)
                    .then(() => {
                        messagebox.close();
                        vm.$swal(i18n.t('delete.succesvol'), `${vm.title.toLowerCase()} ${i18n.t('delete.isverwijderd')}`, "success");  
                        this.$emit('onDeleted') 
                        if(!vm.noRedirect) {
                            vm.$router.push({ name: `${vm.resource}:index` });
                        }
                    })
                    .catch(() => {
                        messagebox.close();
                        vm.$swal(i18n.t('delete.mislukt'), `${vm.title.toLowerCase()} ${i18n.t('delete.konnietwordenverwijderd')}`, "error");
                    });
                }
            })
        }
    }
}
</script>
<style>
.sweet_loader {
	width: 140px;
	height: 140px;
	margin: 0 auto;
	animation-duration: 0.5s;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	animation-name: ro;
	transform-origin: 50% 50%;
	transform: rotate(0) translate(0,0);
}
@keyframes ro {
	100% {
		transform: rotate(-360deg) translate(0,0);
	}
}
</style>